import { useMemo } from 'react';
import { useProducts } from '../products';
import { useEpicCounts } from './useEpicCounts';
import { useReviewData } from './useReviewData';
import { mergeQuarterData, buildQuartersDataForProduct } from '../../api/projects';
import type { AllQuartersData } from '../../api/shared/types';

export function useMultipleProductsQuartersData(
  projectNames: string[],
  fiscalYearQuarters: string[],
  fiscalYear?: string
) {
  const { data: products = [] } = useProducts({ limit: 1000, fiscalYear });
  const { data: epicCounts = [], isLoading: epicCountsLoading } = useEpicCounts(fiscalYearQuarters);
  const { data: reviewData = [], isLoading: reviewDataLoading } = useReviewData(fiscalYearQuarters);

  const data = useMemo((): Record<string, AllQuartersData> => {
    if (!products.length || !projectNames.length) return {};
    const quarterDataItems = mergeQuarterData(epicCounts, reviewData);
    const result: Record<string, AllQuartersData> = {};
    for (const name of projectNames) {
      result[name] = buildQuartersDataForProduct(products, name, fiscalYearQuarters, quarterDataItems);
    }
    return result;
  }, [products, epicCounts, reviewData, projectNames, fiscalYearQuarters]);

  return {
    data,
    isLoading: epicCountsLoading || reviewDataLoading,
    isError: false,
  };
}
